// @flow
import {
  OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  DELETE_SEARCH_NOTIFICATION_REQUEST,
} from './actionTypes';
import type { SearchNotification } from '../types';

export function openSearchNotificationConfirmDeleteModal(
  notification: SearchNotification<*>
): TrovitAction {
  return {
    type: OPEN_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
    payload: notification,
  };
}

export function closeSearchNotificationConfirmDeleteModal(): TrovitAction {
  return {
    type: CLOSE_SEARCH_NOTIFICATION_CONFIRM_DELETE_MODAL,
  };
}

export function deleteSearchNotification(): TrovitAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_REQUEST,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/DeleteSearchNotification/actions.js